import { Avatar, ConversationHeader } from '@chatscope/chat-ui-kit-react';
import { Button } from '@mui/material';
import GGbotGIF from '../../assets/Gifs/bot.gif';
import NavbarLayout from '../../common/NavbarLayout';
import { useNavigate } from 'react-router-dom';

const GGBotNavbar = () => {
  const navigate = useNavigate()
  const handleNavigateBack = () => {
    navigate(-1)
  }
  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <ConversationHeader
      style={{
        background: '#fff',
        padding: 0,
        border: 0,
      }}
    >
      <Avatar
        className='chatAvatar'
        style={{
          border: '2px solid #03a9f4',
        }}
        name='GG bot'
        status='available'
        size='md'
        src={GGbotGIF}
      />
      <ConversationHeader.Content>
        <b>GG AI bot</b>
      </ConversationHeader.Content>
    </ConversationHeader>
    </NavbarLayout>
  );
};

export default GGBotNavbar;
